import React from "react";
import "./button.css";

// 1. Extend the native button attributes so 'disabled' is inherently supported
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "outline" | "glass";
  size?: "sm" | "md" | "lg";
}

const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  size = "md",
  onClick,
  type = "button",
  className = "",
  children,
  ...props // 2. Collect all other standard attributes (like disabled) into 'props'
}) => {
  const variantClass = {
    primary: "button-primary",
    secondary: "button-secondary",
    outline: "button-outline",
    glass: "button-glass",
  }[variant];

  const classes = [
    "button-component",
    variantClass,
    `button-${size}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    /* 3. Spread 'props' onto the element so 'disabled={loading}' gets physically applied */
    <button type={type} className={classes} onClick={onClick} {...props}>
      {children}
    </button>
  );
};

export default Button;